import { Typography } from '@mui/material';
import Slider from '@mui/material/Slider';
import React from 'react';
import { makeStyles } from 'tss-react/mui';

interface Props {
  value: number;
  max: number;
  id: string;
  leftText: string;
  rightText: string;

  handleChange(value: number | number[], id: string): void;
}

const PaiStepSlider: React.FC<Props> = ({ value, max, id, rightText, leftText, handleChange }) => {
  const onChange = (event: Event, newValue: number | number[]) => {
    handleChange(newValue, id);
  };
  const { classes } = useStyles();

  return (
    <div className={classes.sliderContainer}>
      <Slider className={classes.slider} marks={true} value={value} min={0} max={max} step={1} onChange={onChange} />
      <div className={classes.leftText}>
        <Typography className={classes.graphText}>{leftText}</Typography>
      </div>
      <div className={classes.rightText}>
        <Typography className={classes.graphText}>{rightText}</Typography>
      </div>
    </div>
  );
};

const useStyles = makeStyles()((theme) => ({
  sliderContainer: {
    position: 'relative',
    width: '100%',
    marginBottom: '16px',
  },
  slider: {
    height: '6px',
    padding: '11px 0px',
    '& .MuiSlider-rail': {
      backgroundColor: theme.palette.greys.lighter,
      opacity: 1,
    },
    '& .MuiSlider-track': {
      backgroundColor: theme.palette.greys.lighter,
      border: 'none',
    },
    '& .MuiSlider-mark': {
      backgroundColor: theme.palette.primary.main,
      height: '6px',
      width: '3px',
    },
    '& .MuiSlider-thumb::after': {
      borderRadius: 0,
      backgroundColor: theme.palette.primary.main,
      width: '20px',
      height: '20px',
    },
    '& .MuiSlider-thumb:hover, & .Mui-focusVisible': {
      boxShadow: 'none',
    },
  },
  graphText: {
    fontSize: theme.typography.pxToRem(13),
  },
  leftText: {
    position: 'absolute',
    textAlign: 'left',
    left: 0,
    top: '32px',
  },
  rightText: {
    position: 'absolute',
    textAlign: 'right',
    right: 0,
    top: '32px',
  },
}));

export default PaiStepSlider;
